<template>
  <div class="flex h-full w-full justify-between gap-2 2xl:gap-12">
    <div
      v-if="getVisualizationMode === 'card'"
      class="dark:border-ontick-steel-400 border-ontick-steel-300 dark:bg-ontick-graphite-500 min-h-full w-full space-y-1.5 overflow-y-auto border-r-2 bg-gray-100 p-1.5 backdrop-blur-sm backdrop-filter dark:bg-opacity-50"
    >
      <div
        class="flex h-full w-full items-center justify-center text-sm font-medium uppercase"
        v-if="!cardSymbols.length"
      >
        <span> Zerado </span>
      </div>
      <template v-else>
        <div
          v-for="symbol in cardSymbols"
          :key="symbol.name"
          class="grid h-4 gap-1.5"
          :class="item.type === 'PORTFOLIO' ? ' grid-cols-3 ' : 'grid-cols-2'"
        >
          <span
            class="bg-ontick-blue-900 flex h-full max-w-[72px] items-center justify-center rounded-sm text-[10px] font-semibold uppercase tracking-wide text-white"
          >
            {{ symbol.name }}
          </span>
          <!-- <div class="grid w-full grid-cols-2 gap-2"> -->
          <div class="flex items-center gap-1" v-if="item.type === 'PORTFOLIO' || symbol.buy_volume">
            <span
              class="h-full rounded-sm px-1 text-[10px] font-semibold"
              :class="
                symbol.buy_volume === 0 ? 'bg-gray-500 text-gray-300' : 'bg-ontick-yellow-800 text-ontick-graphite-500'
              "
            >
              C
            </span>
            <span class="text-xs font-semibold" :class="{ 'text-gray-500': symbol.buy_volume === 0 }">
              {{ symbol.buy_volume || "-" }}
            </span>
          </div>
          <div class="flex items-center gap-1" v-if="item.type === 'PORTFOLIO' || symbol.sell_volume">
            <span
              class="h-full rounded-sm px-1 text-[10px] font-semibold"
              :class="
                symbol.sell_volume === 0 ? 'bg-gray-500 text-gray-300' : 'bg-ontick-yellow-800 text-ontick-graphite-500'
              "
            >
              V
            </span>
            <span class="text-xs font-semibold" :class="{ 'text-gray-500': symbol.sell_volume === 0 }">
              {{ symbol.sell_volume || "-" }}
            </span>
          </div>
          <!-- </div> -->
        </div>
      </template>
    </div>
    <div class="flex gap-2" :class="getVisualizationMode === 'card' ? 'flex-col' : 'w-full items-end justify-between'">
      <div
        class="flex flex-col gap-0.5"
        :class="{ 'items-end': getVisualizationMode === 'card' }"
        v-tippy="{ arrow: true, theme: 'green' }"
        content="Resultado da operação em aberto"
      >
        <span class="text-xs text-gray-500 dark:text-gray-400"> Resultado </span>
        <div class="flex items-center gap-1 text-sm">
          <ontick-loading-ellipsis-component v-if="openPnl == null || openPnl == undefined" />
          <i v-html="$icons.play_green" v-else-if="openPnl > 0"></i>
          <i v-html="$icons.play_red" v-else-if="openPnl < 0"></i>
          <i class="h-3 w-3 rounded-full bg-gray-500 dark:bg-gray-400" v-else></i>
          <span class="whitespace-nowrap font-semibold">
            {{ openPnl | currency }}
          </span>
        </div>
      </div>
      <div
        class="flex flex-col gap-0.5"
        :class="{ 'items-end': getVisualizationMode === 'card' }"
        v-tippy="{ arrow: true, theme: 'green' }"
        content="Resultado acumulado do dia"
      >
        <span class="text-xs text-gray-500 dark:text-gray-400"> Acumulado </span>
        <div class="flex items-center gap-1">
          <i v-html="$icons.play_green" v-if="closedPnl > 0"></i>
          <i v-html="$icons.play_red" v-else-if="closedPnl < 0"></i>
          <i class="h-3 w-3 rounded-full bg-gray-500 dark:bg-gray-400" v-else></i>
          <span class="whitespace-nowrap text-sm font-semibold">
            {{ closedPnl | currency }}
          </span>
        </div>
      </div>
      <div
        class="flex flex-col gap-0.5"
        :class="{ 'items-end': getVisualizationMode === 'card' }"
        v-tippy="{ arrow: true, theme: 'green' }"
        content="Exposição atual/exposição máxima"
      >
        <span class="text-xs text-gray-500 dark:text-gray-400"> Exposição </span>
        <div
          class="flex items-center gap-1 text-sm"
          :class="{
            'justify-end': getVisualizationMode === 'mini-card',
          }"
        >
          <p class="whitespace-nowrap text-gray-500 dark:text-gray-400">
            <template v-if="item.type === 'PORTFOLIO'">
              <span class="text-ontick-carbon-900 font-semibold dark:text-gray-300">
                {{ currentExposure }}
              </span>
              <span>{{ "/" }}</span>
              <span>{{ item.max_exposure }}</span>
            </template>
            <span v-else class="text-ontick-carbon-900 font-semibold dark:text-gray-300">
              {{ currentExposure | currency }}
            </span>
          </p>
          <i
            v-if="Object.keys(item).includes('pending_schedule')"
            class="p-1.5 cursor-pointer"
            v-html="$icons.warn_num_contracts"
            v-tippy="{ arrow: true, theme: 'green', placement: 'right' }"
            content="Alteração de volume agendada."
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    item: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters({
      getVisualizationMode: "investment/getVisualizationMode",
      getUiTheme: "config/getUiTheme",
      getSelectedAccount: "accountTypes/getSelectedAccount",
    }),
    closedPnl() {
      if (this.item.type === "PORTFOLIO") {
        return (
          this.item.sub_strategies.reduce((acc, curr) => {
            return acc + (curr.position_profit || 0) + (curr?.closed_pnl || 0);
          }, 0) + (this.item?.closed_pnl || 0)
        );
      } else if (this.item.strategy_symbol === "ANY" && this.item?.curr_positions) {
        return (
          this.item.curr_positions.reduce((acc, curr) => {
            return acc + (curr.position_profit || 0);
          }, 0) + (this.item?.closed_pnl || 0)
        );
      }
      return 0;
    },
    openPnl() {
      if (this.item.type === "PORTFOLIO") {
        return this.item.sub_strategies.reduce((acc, curr) => acc + (curr.open_pnl || 0), 0);
      } else {
        return this.item.curr_positions.reduce((acc, curr) => acc + (curr.open_pnl || 0), 0);
      }
    },
    currentExposure() {
      if (this.item.type === "PORTFOLIO") {
        return this.item.sub_strategies.reduce((acc, item) => {
          return acc + (item.position_volume || 0);
        }, 0);
      } else {
        // MULTI ATIVOS
        let prices = this.item.curr_positions.map((position) => position.position_volume * position.position_price_avg);
        return Number(prices.reduce((acc, curr) => acc + curr, 0).toFixed(0));
      }
    },
    cardSymbols() {
      if (this.item.type === "PORTFOLIO") {
        let strategies = this.item.sub_strategies;
        let symbols = Array(...new Set(strategies.map((sub) => sub.strategy_symbol)));
        let positionsBySymbol = symbols.map((symbol) => {
          return {
            name: symbol,
            buy_volume: strategies
              .filter(
                (strategy) =>
                  strategy.strategy_symbol === symbol && ["Comprado", "BUY"].includes(strategy.position_status)
              )
              .reduce((acc, curr) => acc + (curr.position_volume || 0), 0),
            sell_volume: strategies
              .filter(
                (strategy) =>
                  strategy.strategy_symbol === symbol && ["Vendido", "SELL"].includes(strategy.position_status)
              )
              .reduce((acc, curr) => acc + (curr.position_volume || 0), 0),
          };
        });
        return positionsBySymbol;
      } else {
        return this.item.curr_positions
          .filter((position) => position.position_status != "Zerado")
          .map((position) => {
            return {
              name: position.position_symbol,
              buy_volume: ["Comprado", "BUY"].includes(position.position_status) ? position.position_volume : 0,
              sell_volume: ["Vendido", "SELL"].includes(position.position_status) ? position.position_volume : 0,
            };
          });
      }
    },
  },
};
</script>

<style></style>
